import { useEffect, useState } from 'react';
import ListaSiniestro from './ListaSiniestro';
import FormSiniestroII from './FormSiniestroII';
import GeointSorisegHeader from './GeointSorisegHeader';
import { ProgressSpinner } from 'primereact/progressspinner';
import { recuperaRolesByUser } from '../../services/Siniestro/SiniestroService';

const AdminSiniestro = () => {
    const [vista, setVista] = useState('LISTA');
    const [siniestroSeleccion, setSiniestroSeleccion] = useState(null);
    const [cargando, setCargando] = useState(false);
    const [esAdministrador, setEsAdministrador] = useState(false);

    const ROL_ADMINISTRADOR_SINIESTROS = 'ADMINISTRADOR DE SINIESTROS';

    useEffect(() => {
        const recuperaRolesUsu = async () => {
            try {
                setCargando(true);
                const datos = await recuperaRolesByUser();
                //console.log('DATOS ROLES...:', datos)
                const admin = datos.some((item) => item.rolName === ROL_ADMINISTRADOR_SINIESTROS);
                if (admin) {
                    setEsAdministrador(true);
                }
            } catch (error) {
                console.error('ERROR: Al recuperar los roles del usuario', error);
            } finally {
                setCargando(false);
            }
        };
        recuperaRolesUsu();
    }, []);

    const nuevoSiniestro = () => {
        setVista('NUEVO');
    };
    const volverListado = () => {
        setVista('LISTA');
    };

    const irEdita = (siniestro) => {
        setSiniestroSeleccion(siniestro);
        setVista('EDITAR');
    };

    return (
        <>
            <GeointSorisegHeader subtitle="Gestión de Eventos Delictivos" />
            {cargando ? (
                <ProgressSpinner style={{ width: '50px', height: '50px' }} animationDuration="1.s" />
            ) : (
                <>
                    {vista === 'LISTA' && (
                        <ListaSiniestro funcNuevo={nuevoSiniestro} funcEdita={irEdita} esAdmin={esAdministrador} />
                    )}
                    {vista === 'NUEVO' && <FormSiniestroII funcVolver={volverListado} esAdmin={esAdministrador} />}
                    {vista === 'EDITAR' && (
                        <FormSiniestroII funcVolver={volverListado} datosSiniestro={siniestroSeleccion} esAdmin={esAdministrador} />
                    )}
                </>
            )}
        </>
    );
};
export default AdminSiniestro;
